<template>
  <div
    :style="{
      width: direction === 'horizontal' ? 'calc(100% - 10px) !important' : '100%',
    }"
    :class="direction === 'horizontal' ? 'p-5 flex items-center' : ''"
    class="cursor-pointer overflow-hidden rounded-12 bg-white shadow"
    @click="$push({
      path: '/course/courseDetail',
      query: {
        id: data.objectId || '&&&&&'
      },
    })"
  >
    <!-- 图片 -->
    <div
      class="course-card-image-wrap"
      :style="{ width: direction === 'horizontal' ? '50%' : '100%' }"
    >
      <van-image
        width="100%"
        :height="direction === 'horizontal' ? 'auto' : ''"
        lazy-load
        :src="data.coverPicture || ''"
        fit="cover"
        :class="[
          direction === 'horizontal' ? 'rounded-12 overflow-hidden' : '',
          direction === 'vertical' ? 'card-image-vertical' : 'card-image-horizontal'
        ]"
      />
      <div
        v-if="isMyCourse"
        class="course-card-tag"
      >
        <my-course-tag />
      </div>
    </div>
    <div
      :style="{ width: direction === 'horizontal' ? 'calc(50% - 10px) !important' : '100%' }"
      :class="direction === 'horizontal' ? 'h-auto pl-10' : 'p-10 h-110'"
    >
      <!-- 标题 -->
      <div class="text-13 line-height-22 line-2">
        {{ data.title ? data.title : '该课程不存在' }}
      </div>
      <!-- 简介 -->
      <div
        class="mt-5 text-11 line-height-22 text-gray line-1"
      >
        {{ data.introduction ? data.introduction : '暂无简介' }}
      </div>
      <!-- 金额 -->
      <div class="flex items-center justify-between">
        <div class="mt-8 text-14 font-bold line-height-14 text-orange">
          {{ priceText }}
        </div>
        <div
          v-if="data.price > 0 && isShowExchangeCount"
          class="text-10 text-gray"
        >
          {{ `${count}人兑换` }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import MyCourseTag from './MyCourseTag.vue'

export default {
  name: 'CourseCard',
  components: {
    MyCourseTag
  },
  data () {
    return {
      exchangeCount: 0,
    }
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          title: '',
          price: 0,
          objectId: '',
          introduction: '',
          coverPicture: '',
          exchangeQuantity: 0
        }
      },
    },
    direction: {
      type: String,
      default: 'vertical',
    },
  },
  computed: {
    ...mapGetters(['isShowExchangeCount']),
    ...mapState(['myCourseIds']),
    isMyCourse () {
      return this.myCourseIds.includes(this.data.objectId)
    },
    count () {
      return this.data.exchangeQuantity || this.exchangeCount
    },
    hours () {
      const catalog = this.data && this.data.courseCatalog
      if (!catalog || !Array.isArray(catalog.list) || !catalog.list.length) {
        return 0
      }
      if (catalog.type) {
        return catalog.list.reduce((total, section) => {
          if (!section || !Array.isArray(section.list)) {
            return total
          }
          return total + section.list.length
        }, 0)
      }
      const first = catalog.list[0]
      if (first && Array.isArray(first.list)) {
        return first.list.length
      }
      return 0
    },
    priceText () {
      const price = this.data && this.data.price
      const base = price ? `￥${price}` : '免费'
      if (!this.hours) {
        return base
      }
      return `${base} / ${this.hours} 课时`
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      if (!this.data.objectId) { return }
      if (!this.isShowExchangeCount) { return }
      this.exchangeCount = await this.statisticsNum('exchangeRecord', {
        course: this.data.objectId,
        status: '已使用',
      })
    },
  },
}
</script>

<style scoped lang="scss">
.course-card-image-wrap {
  position: relative;
}

.course-card-tag {
  position: absolute;
  top: 4px;
  right: 6px;
  z-index: 1;
}

.card-image-vertical ::v-deep .van-image__img {
  width: 100%;
  display: block;
  object-fit: cover;
  aspect-ratio: 4 / 3;
}

.card-image-horizontal ::v-deep .van-image__img {
  width: 100%;
  display: block;
  object-fit: cover;
  aspect-ratio: 16 / 9;
}
</style>
